export const otmNavItems = [
  {
    id: "dashboard",
    href: "/xtm/home",
    label: "360_RECRUITER_INSIGHTS_OTM_SIDEBAR_DASHBOARD",
    icon: "NavigationBusinessServices",
  },
  {
    id: "hotleads",
    href: "/xtm/promising-candidates",
    label: "360_RECRUITER_INSIGHTS_OTM_SIDEBAR_HOTLEADS",
    icon: "NavigationCommunities",
  },
  {
    id: "projects",
    href: "/xtm/projects/personal",
    label: "360_RECRUITER_INSIGHTS_OTM_SIDEBAR_PROJECTS",
    icon: "FolderProjects",
  },
  {
    id: "messages",
    href: "/xtm/inbox",
    label: "360_RECRUITER_INSIGHTS_OTM_SIDEBAR_MESSAGES",
    icon: "NavigationMessages",
  },
  {
    id: "search",
    href: "/xtm/search",
    label: "360_RECRUITER_INSIGHTS_OTM_SIDEBAR_SEARCH",
    icon: "CoreSearch",
  },
]

export const otpNavItems = [
  {
    id: "talent_pools",
    href: "/xtm/pools/automatic",
    label: "360_RECRUITER_INSIGHTS_OTM_SIDEBAR_TALENT_POOLS",
    icon: "FolderPools",
  },
]

export const getAdminNavItems = (isXtmAdmin, isXtpAdmin) => [
  ...(isXtmAdmin
    ? [
        {
          id: "projects",
          href: "/xtm/admin/projects",
          label: "360_RECRUITER_INSIGHTS_OTM_SIDEBAR_MANAGE_PROJECTS",
        },
      ]
    : []),
  ...(isXtpAdmin
    ? [
        {
          id: "pools",
          href: "/xtm/admin/pools",
          label: "360_RECRUITER_INSIGHTS_OTM_SIDEBAR_MANAGE_POOLS",
        },
        {
          id: "company_connections",
          href: "/xtm/admin/company_connections",
          label: "360_RECRUITER_INSIGHTS_OTM_SIDEBAR_EMPLOYER_PROFILES",
        },
      ]
    : []),
  {
    id: "recruiting_settings",
    href: "/recruiting-settings?sc_o=profile_personal_settings_xtm",
    label: "360_RECRUITER_INSIGHTS_OTM_SIDEBAR_TEAM_PERMISSIONS",
    target: "_blank",
  },
  {
    id: "team_messages",
    href: "/xtm/admin/conversations",
    label: "360_RECRUITER_INSIGHTS_OTM_SIDEBAR_TEAM_MESSAGES",
  },
]

export const DELAY = 0.025
export const FADEIN = `max-height:100px;opacity:1;`
export const FADEOUT = `max-height:0px;opacity:0;`
export const EMPTY_ICON_SPACE = "28px"
